import { Badge, Button, Dropdown, Grid } from "antd";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Hamburger from "../../../../../assets/images/icons/Hamburger";
import ShopingCart from "../../../../../assets/images/icons/ShopingCart";
import User from "../../../../../assets/images/icons/User";
import UserIsLogin from "../../../../../assets/images/icons/UserIsLogin";
import { LanguageDropdown } from "../../../../../components";
import { P1 } from "../../../../../components/NormalFonts";
import { useAuth } from "../../../../../context/AuthContext";
import { useLayout } from "../../../../../context/LayoutContext";
import { useScroll } from "../../../../../context/ScrollContext";
import { MenuType } from "../../data";
import styles from "./styleModule";

const HeaderContainer = ({
  handleLogoClick,
  handleLoginClick,
  onMenuOpen,
  messageUnread,
  MENU,
  PROFILE,
  cartStatus,
}: {
  handleLogoClick: () => void;
  handleLoginClick: () => void;
  onMenuOpen: () => void;
  messageUnread: {
    has_unread_message: boolean;
  };
  MENU: MenuType[];
  PROFILE: MenuType[];
  cartStatus: boolean;
}) => {
  const LOGO_ALT =
    "北海道中文滑雪學校｜涵蓋星野・二世古・藏王・札幌手稻等雪場的教練預約平台｜Jstyle Ski";
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const { getHeaderPadding } = useLayout();
  const { isTop } = useScroll();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [showLanguageDrawer, setShowLanguageDrawer] = useState<boolean>(false);

  const getMenuGap = () => {
    if (screens.xl) return "var(--menu-gap-xl)";
    if (screens.lg) return "var(--menu-gap-lg)";
    if (screens.md) return "var(--menu-gap-md)";
    return "16px";
  };

  const getMenuFontSize = () => {
    if (screens.lg) return "var(--menu-fontsize-lg)";
    if (screens.md) return "var(--menu-fontsize-md)";
    return "var(--menu-fontsize-md)";
  };

  const renderMenu = () => {
    if (screens.md) {
      return MENU.filter((_menu: MenuType) => _menu.visible === true).map(
        (_menu: MenuType) => {
          return (
            <Link
              style={{ fontSize: getMenuFontSize() }}
              className={`${styles.menu} ${
                window.location.pathname ===
                  `${process.env.PUBLIC_URL}${_menu.path}` ||
                (window.location.pathname.includes(
                  `${process.env.PUBLIC_URL}${_menu.extraPath}`,
                ) &&
                  !_menu.ignorePath?.includes(window.location.pathname))
                  ? styles.active
                  : ""
              }`}
              // onClick={() => handleScroll(_menu.key)}
              to={_menu.path}
              key={_menu.key}
            >
              {_menu.label}
            </Link>
          );
        },
      );
    }
    return (
      <h1 style={{ padding: 0, margin: 0 }}>
        <img
          src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/header_logo.png`}
          alt={LOGO_ALT}
          className={`${styles.logo} ${styles.small}`}
          onClick={handleLogoClick}
        />
      </h1>
    );
  };

  const getDropdownItem = () => {
    return PROFILE.filter((_profile) => _profile.visible === true).map(
      (_profile) => {
        return {
          key: _profile.key,
          label: (
            <div
              className={`${styles.menuitem} ${
                window.location.pathname === _profile.path ? styles.active : ""
              }`}
              onClick={
                _profile.onClick
                  ? _profile.onClick
                  : () => navigate(_profile.path)
              }
            >
              <Badge dot={_profile.dot}>
                <P1 color="var(--Neutral-dark-70)">{_profile.label}</P1>
              </Badge>
            </div>
          ),
        };
      },
    );
  };

  const renderLogin = () => {
    if (screens.md) {
      if (!isAuthenticated) {
        return (
          <>
            <Badge dot={cartStatus ? cartStatus : false}>
              <Button
                type={"primary"}
                icon={<ShopingCart style={{ fontSize: 18 }} />}
                onClick={handleLoginClick}
              />
            </Badge>
            <Button
              type={"primary"}
              icon={<User style={{ fontSize: 18 }} />}
              style={{
                background: "var(--header-right-user-bg)",
              }}
              onClick={handleLoginClick}
            />
          </>
        );
      }
      return (
        <>
          <Badge dot={cartStatus ? cartStatus : false}>
            <Button
              type={"primary"}
              icon={<ShopingCart style={{ fontSize: 18 }} />}
              onClick={() => {
                navigate("/cart");
              }}
            />
          </Badge>
          <Dropdown
            menu={{ items: getDropdownItem() }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Badge dot={messageUnread?.has_unread_message || false}>
              <Button
                type={"primary"}
                icon={<UserIsLogin style={{ fontSize: 18 }} />}
                // onClick={() => {
                //   onMenuProfileOpen();
                // }}
              />
            </Badge>
          </Dropdown>
        </>
      );
    }

    return (
      <div className={styles.loginContainer}>
        <Badge dot={cartStatus ? cartStatus : false}>
          <Button
            className={styles.icon}
            size={"small"}
            shape={"circle"}
            type={"primary"}
            icon={
              <ShopingCart
                style={{ color: "var(--primary-90)", fontSize: 24 }}
              />
            }
            onClick={() => {
              if (!isAuthenticated) {
                handleLoginClick();
                return;
              }
              navigate("/cart");
            }}
          />
        </Badge>
      </div>
    );
  };

  return (
    <div
      className={`${styles.headerContainer} header-container`}
      style={{
        padding: getHeaderPadding(),
        background: isTop
          ? "transparent"
          : pathname === "/record"
            ? "var(--bg)"
            : "linear-gradient(180deg, #F0EFEF 55%, rgba(240, 239, 239, 0.00) 100%)",
      }}
      id="header-container"
    >
      <div
        className={`${styles.headerBar} ${screens.lg ? "" : styles.middle} ${
          screens.md ? "" : styles.small
        }`}
      >
        <div className={styles.componentLeft}>
          {screens.md ? (
            <h1 style={{ padding: 0, margin: 0 }}>
              <img
                src={`/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/header_logo.png`}
                alt={LOGO_ALT}
                className={`${styles.logo} ${screens.xs ? styles.small : ""}`}
                onClick={handleLogoClick}
              />
            </h1>
          ) : (
            <LanguageDropdown
              showDrawer={showLanguageDrawer}
              setShowDrawer={setShowLanguageDrawer}
            />
          )}
        </div>
        <div className={styles.menuWrapper}>
          <div
            className={styles.leftEdge}
            style={{
              background: `url("/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/header/left-edge.svg")
            no-repeat center / cover`,
            }}
          />
          <div
            className={styles.componentCenter}
            style={{
              gap: getMenuGap(),
            }}
          >
            {renderMenu()}
          </div>
          <div
            className={styles.rightEdge}
            style={{
              background: `url("/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/header/right-edge.svg")
            no-repeat center / cover`,
            }}
          />
        </div>
        <div className={styles.componentRight}>
          {renderLogin()}

          {screens.md ? (
            <LanguageDropdown
              showDrawer={showLanguageDrawer}
              setShowDrawer={setShowLanguageDrawer}
            />
          ) : (
            <Badge
              dot={messageUnread?.has_unread_message || false}
              offset={[-1, 1]}
            >
              <Button
                className={styles.icon}
                size={"small"}
                shape={"circle"}
                icon={<Hamburger />}
                type={"primary"}
                onClick={onMenuOpen}
              />
            </Badge>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeaderContainer;
